import { OnboardingState, OnboardingStep } from './types';

export const accountOnboardingBasePath = (account: { slug: string }) =>
  `/${account.slug}/onboarding`;

export const shouldRedirectToOnboarding = (
  account: { slug: string; isOnboarded: boolean },
  pathname: string,
) => !pathname.startsWith(accountOnboardingBasePath(account)) && !account.isOnboarded;

const getStepPath = (step: OnboardingStep, account: { slug: string }) => {
  switch (step) {
    case 'start':
      return `${accountOnboardingBasePath(account)}/start`;
    case 'legal':
      return `${accountOnboardingBasePath(account)}/legal`;
    case 'welcomeSurvey':
      return `${accountOnboardingBasePath(account)}/welcome-survey`;
    case 'setupCall':
      return `${accountOnboardingBasePath(account)}/setup-call`;
    case 'connection':
      return `${accountOnboardingBasePath(account)}/connection`;
    case 'complete':
      return `${accountOnboardingBasePath(account)}/complete`;
    default:
      throw new Error(`Unknown onboarding step: ${step}`);
  }
};

const getNextStep = (onboardingState: OnboardingState): OnboardingStep => {
  const { hasConsented, hasConnection, hasPassedSetupCallStep, hasBookedSetupCall, welcomeSurvey } =
    onboardingState;
  return !hasConsented
    ? 'legal'
    : welcomeSurvey === undefined
      ? 'welcomeSurvey'
      : !hasBookedSetupCall && !hasPassedSetupCallStep
        ? 'setupCall'
        : !hasConnection
          ? 'connection'
          : !hasBookedSetupCall
            ? 'setupCall'
            : 'complete';
};

export const getNextStepPath = (onboardingState: OnboardingState, account: { slug: string }) =>
  onboardingState.hasOnboarded ? '/' : getStepPath(getNextStep(onboardingState), account);
